export const attachApiResolver = ({ ioc, methods, resolve, }) => new Proxy(ioc, {
    get(target, property) {
        if (property === 'resolve') {
            return resolve;
        }
        if (methods.includes(property)) {
            return (...args) => {
                target[property](...args);
                return attachApiResolver({ ioc, methods, resolve });
            };
        }
        return target[property];
    },
});
